import { getFromStorage } from "@shared/utils";
import { proxy, subscribe, useSnapshot } from "valtio/index";
import { RegionV4 } from "@shared/types/riot";
import { fetchRSOAccount, fetchRSOToken, RSOAccount } from "@shared/api/rso";
import { authState } from "@shared/states/authState";
import { useEffect } from "react";

interface RSOState {
	token?: {
		token: string;
		expires_at: string;
		region: RegionV4;
	};
	account?: RSOAccount;
	isLoading: boolean;
}

const saved = getFromStorage("rso", { isLoading: false });

export const rsoState = proxy<RSOState>(saved);

subscribe(rsoState, () => {
	localStorage.setItem(
		"rso",
		JSON.stringify({
			token: rsoState.token,
			account: rsoState.account,
		}),
	);
});

export const updateRSOToken = async () => {
	if (!authState?.accessToken || rsoState.isLoading) {
		return;
	}

	try {
		rsoState.isLoading = true;

		const token = await fetchRSOToken();
		if (!token.ok) {
			// TODO error
			return;
		}
		const account = await fetchRSOAccount(token.token);
		if (!account.ok) {
			// TODO error
			return;
		}

		rsoState.token = token;
		rsoState.account = account;
	} finally {
		rsoState.isLoading = false;
	}
};

export const clearRSOState = () => {
	rsoState.token = undefined;
	rsoState.account = undefined;
};

export const useRSOToken = () => {
	const rsoSnap = useSnapshot(rsoState);

	const expiry = rsoSnap.token?.expires_at;
	const expired = !expiry || new Date() > new Date(expiry);

	useEffect(() => {
		if (!expired) return;

		updateRSOToken();
	}, [expired]);

	return {
		loading: rsoSnap.isLoading,
		token: rsoSnap.token,
		account: rsoSnap.account,
	};
};
